import { render, staticRenderFns } from "./IzinCuti.vue?vue&type=template&id=efaead2e&scoped=true"
import script from "./IzinCuti.vue?vue&type=script&lang=js"
export * from "./IzinCuti.vue?vue&type=script&lang=js"
import style0 from "./IzinCuti.vue?vue&type=style&index=0&id=efaead2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaead2e",
  null
  
)

export default component.exports